import { Model } from 'vuex-orm';

import App from '../app/model';
import Company from '../company/model';

export default class Category extends Model {
  static entity = 'categories';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      app_id: this.attr(null),
      name: this.attr(''),
      type: this.attr(''),
      editable: this.attr(''),
      default: this.attr(''),
      status: this.attr(''),

      app: this.belongsTo(App, 'app_id'),
      company: this.belongsTo(Company, 'company_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/category/model.js